import { useEffect, useRef } from "react";
import Script from "next/script";

export const ScriptTag = ({ id, src, code = "", strategy = "afterInteractive" }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (strategy === "beforeInteractive") return;

    const container = containerRef.current;

    if (!container) return;

    const mount = () => {
      const el = document.createElement("script");

      if (id) el.id = id;

      if (src) {
        el.src = src;
      } else {
        el.text = code;
      }

      container.appendChild(el);
    };

    const cleanup = () => {
      container.innerHTML = "";
    };

    if (strategy === "lazyOnload" && document.readyState !== "complete") {
      window.addEventListener("load", mount, { once: true });

      return () => {
        window.removeEventListener("load", mount);
        cleanup();
      };
    }

    mount();

    return cleanup;
  }, [id, src, code, strategy]);

  if (strategy === "beforeInteractive") {
    if (src) {
      return <Script id={id} src={src} strategy={strategy} />;
    }

    return <Script id={id} strategy={strategy} dangerouslySetInnerHTML={{ __html: code }} />;
  }

  return <div ref={containerRef} />;
};

export default ScriptTag;
